module.exports = __webpack_public_path__ + "media/images/company-logos/swiss-lung-association-logo-6a0d85308afe9593e69b703d0d7859a9.jpg";